import Layout from "components/layout/Layout";
const Terms = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Terms <span>of use</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        Welcome to BodyLytiX! These Terms of Use govern your access to and use of our platform, including our mobile and web applications, services, and features. By using BodyLytiX, you agree to comply with these Terms. Please read them carefully.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        1. Acceptance of Terms
                                    </strong>
                                    <p className="info-one">
                                        By accessing or using BodyLytiX, you agree to be bound by these Terms of Use, our Privacy Policy, and any additional terms applicable to specific features. If you do not agree, you may not use our services.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        2. Eligibility
                                    </strong>
                                    <p className="info-one">
                                        You must be at least 18 years old or the age of majority in your jurisdiction to use BodyLytiX. By using our platform, you represent and warrant that you meet these eligibility requirements.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        3. Account Registration
                                    </strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Accurate Information: 
                                            </strong>
                                            <span> You must provide accurate and complete information during registration and keep it updated.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Account Security: 
                                            </strong>
                                            <span> You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Notify us immediately of any unauthorized access or breach.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        4. Use of Services
                                    </strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Permitted Use: 
                                            </strong>
                                            <span> BodyLytiX is for personal, non-commercial use unless otherwise agreed in writing.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Prohibited Activities: 
                                            </strong>
                                            <span> You agree not to:</span>
                                            <ul>
                                                <li>
                                                    Reverse engineer, modify, or hack our platform.
                                                </li>
                                                <li>
                                                    Misuse or interfere with the security features.
                                                </li>
                                                <li>
                                                    Use the platform to violate any laws or regulations.
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        5. Data and Privacy
                                    </strong>
                                    <p className="info-one">
                                        Your use of BodyLytiX is subject to our <a href="/privacy-policy">Privacy Policy</a>, which explains how we collect, use, and protect your data. By using our services, you consent to our data practices.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        6. Payments and Subscriptions
                                    </strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                            Billing: 
                                            </strong>
                                            <span> If you subscribe to a paid plan, you authorize us to charge your payment method for recurring fees until you cancel.</span>
                                        </li>
                                        <li>
                                            <strong>
                                            Refunds: 
                                            </strong>
                                            <span> Subscription fees are non-refundable except as required by law.</span>
                                        </li>
                                        <li>
                                            <strong>
                                            Cancellations: 
                                            </strong>
                                            <span> You may cancel your subscription at any time through your account settings. Cancellation will apply at the end of the current billing cycle.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        7. Intellectual Property
                                    </strong>
                                    <p className="info-one">
                                        All content on BodyLytiX, including logos, designs, text, and software, is the intellectual property of BodyLytiX or its licensors. You may not copy, reproduce, or distribute any part of our platform without prior written consent.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        8. User-Generated Content
                                    </strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                            Ownership: 
                                            </strong>
                                            <span> By submitting content (e.g., custom coaches, comments), you grant BodyLytiX a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content.</span>
                                        </li>
                                        <li>
                                            <strong>
                                            Prohibited Content: 
                                            </strong>
                                            <span> You may not upload content that is unlawful, harmful, defamatory, or infringes on others’ rights.</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        9. Third-Party Integrations
                                    </strong>
                                    <p className="info-one">
                                        BodyLytiX integrates with third-party services (e.g., Garmin, Apple Health). Your use of these integrations is subject to their respective terms and conditions. We are not responsible for third-party content or practices.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        10. Limitation of Liability
                                    </strong>
                                    <p className="info-one">
                                        To the maximum extent permitted by law, BodyLytiX is not liable for any indirect, incidental, or consequential damages arising from your use of the platform. Use BodyLytiX at your own risk.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        11. Termination
                                    </strong>
                                    <p className="info-one">
                                        We reserve the right to suspend or terminate your account if you violate these Terms or engage in activities harmful to BodyLytiX or its users. Termination does not waive any rights or obligations accrued before the termination date.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        12. Changes to These Terms
                                    </strong>
                                    <p className="info-one">
                                        We may update these Terms from time to time. Significant changes will be communicated through the platform or via email. Continued use of BodyLytiX after updates constitutes acceptance of the revised Terms.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>
                                        13. Governing Law
                                    </strong>
                                    <p className="info-one">
                                        These Terms are governed by the laws of [Your Jurisdiction]. Any disputes shall be resolved exclusively in the courts of [Your Jurisdiction].
                                    </p>
                                </div>
                                <div className="job-details-list-wrap">
                                    <p>
                                        By using BodyLytiX, you agree to these Terms of Use. Thank you for being part of the BodyLytiX community and for trusting us with your fitness journey!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default Terms;